<template>
  <div class="app-main-content accounting-document-search">
    <!-- 对应 cargoware的 AccountingDocumentList -->
    <accounting-document-list />
  </div>
</template>

<script>
import AccountingDocumentList from '@/views/cargo/v0/FinanceManage/AccountingDocumentSearch/AccountingDocumentList'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
export default {
  name: 'AccountingDocumentSearch',
  components: { AccountingDocumentList },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
  }
}
</script>

<style scoped>

</style>
